import { StyledButton } from "../StyledComponents";
import AppleSignin from "react-apple-signin-auth";
import { APPLE_OAUTH_CLIENT_ID } from "@constants";
import { theme } from "@utilities";
import { ClipLoaderCommon } from "@components";
const BaseUrl = process.env.REACT_APP_REDIRECT_URL;

interface CustomAppleSignInProps {
    onBeforeLogin?: () => Promise<boolean | void>;
    isLoading?: boolean;
}

const CustomAppleSignIn = ({ onBeforeLogin, isLoading }: CustomAppleSignInProps = {}) => {
    const handleAppleSignInSuccess = () => undefined;
    const handleAppleSignInError = () => undefined;

    return (
        <AppleSignin
            authOptions={{
                clientId: APPLE_OAUTH_CLIENT_ID,
                scope: "email name",
                redirectURI: `${BaseUrl}`,
                usePopup: false,
            }}
            onSuccess={handleAppleSignInSuccess}
            onError={handleAppleSignInError}
            uiType="dark"
            render={(props: any) => (
                <StyledButton
                    disabled={isLoading}
                    onClick={async () => {
                        // Validate before opening Apple popup
                        if (onBeforeLogin) {
                            const shouldContinue = await onBeforeLogin();
                            if (shouldContinue === false) {
                                return;
                            }
                        }
                        // Store current path with query params before Apple redirect
                        const urlParams = new URLSearchParams(window.location.search);
                        const returnPath = urlParams.get("returnPath");
                        const fullPath =
                            returnPath || window.location.pathname + window.location.search;
                        if (fullPath && !fullPath.startsWith("/login")) {
                            localStorage.setItem("appleLoginReturnPath", fullPath);
                        }
                        props.onClick();
                    }}
                    $borderRadius={theme.borderRadius.small}
                    type="button"
                    color="#131214"
                    $textColor="#ffff"
                >
                    {isLoading ? (
                        <ClipLoaderCommon size={24} color={theme.colors.white} margin={0} />
                    ) : (
                        <>
                            <img src="/images/Apple.svg" alt="Apple Logo" />
                            Continue with Apple
                        </>
                    )}
                </StyledButton>
            )}
        />
    );
};

export default CustomAppleSignIn;
